export default {
  /*按钮*/
  bt:{
    search:"Tìm kiếm",
    query:"Tra cứu",
    operation:"Thao tác",
    add:"Thêm",
    edit:"Sửa",
    delete:"Xóa",
    down:"Tải",
    export:"Dẫn ra",
    upload:"Tải lên",
    enable:"kích hoạt",
    disable:"vô hiệu hóa",
    close:"đóng",
    view:"lượt xem",
    confirm:"xác nhận",
    batchUpdateSwitchCode:"Mã chuyển đổi cập nhật hàng loạt",
    batchUpdateStatus:"Trạng thái cập nhật hàng loạt",
     approved:"approved",
    cancel:"cancel",
    copy:"copy",
        isStopRepeat:"Enable task repetition?",
    isEnablepRepeat:"Disable task repetition?",
    logout:"logout",
    unlock:"unlock",
     redo:"redo",
     back:"back"
    
  },
  /*公用字段或工具函数字段*/
  common:{
    startTime:"Thời gian bắt đầu",
    endTime:"Thời gian kết thúc",
    creator:"Người xây dựng",
    updater:"Người làm mới",
    createTime:"Thời gian xây dựng",
    updateTime:"Thời gian làm mới",
    phone:"Số điện thoại",
    name:"Họ tên",
    email:"Email",
    idNumber:"Số CMND",
    status:"Trạng thái",
    remark:"Ghi chú",
  },
  /*用户追踪页面*/
  kscore:{
    month:"Số kỳ chương trình",
    profit:"Thu nhập",
    detail:"Chi tiết",
    symbol:'Tên sản phẩm',
    direction:'Hướng đặt lệnh',
    openPrice:'Giá đặt lệnh',
    closePrice:'Giá đóng lệnh',
    createTime:'Thời gian đặt lệnh',
  },
  registerLog:{
    dataType:"Loại hình dữ liệu",
    driverType:"Loại hình thiết bị",
    utmSource:"Nguồn",
    utmMedium:"Môi giới",
    utmCampaign:"Hàng loạt quảng cáo",
    utmContent:"Nhóm quảng cáo",
    utmTerm:"Chữ quan trọng",
    ipAddress:"Vị trí IP",
    href:"URLNguồn URL",
    referrer:"Trang đích",
    directPhone:"Số ĐT người giới thiệu",
    phonePre:"Số khu vực",
    title:"Giới tính",
    businessType:"Nhóm nghiệp vụ",
    ruleId:"id id quy tắc tin nhắn",
    register:"Danh sách khách hàng nguyên",
  },
  accountReward:{
    activeId:"IDID chương trình",
    activeStatus:"Trạng thái chương trình",
    activeName:"Tên chương trình",
    activeType:"Loại hình chương trình",
    proposalNo:"Số đề án",
    beginDate:"TG chương trình bắt đầu",
    endDate:"TG chương trình kết thúc",
    expDay:"Thời hạn hiệu lực",
    proposalUser:"Người đề án",
    proposalDate:"TG đề án",
    approvalUser:"Người xét duyệt",
    approvalDate:"TG xét duyệt",
    proposalType:"Loại hình đề án",
    proposalStatus:"Trạng thái đề án",
    applyProposal:"Thực thi đề án",
    cancelProposal:"Hủy đề án",
    applySuccess:"Thực thi thành công",
    applyFail:"Thực thi thất bại",
    choiceOne:"Xin chọn một đề án",
    notSatisfiable:"Đề án không phù hợp yêu cầu",
    haveCancelledCustomer: "Đề xuất không thể bao gồm tài khoản đã bị hủy",
    downloadProActivity:"Đề án về tiền thưởng giới thiệu",
    excuteCustomerNumber:'Số TK thành viên',
    demo:'Loại hình tài khoản',
    levelType:'Cấp độ tài khoản',
    mobilePhone:'Số ĐT',
    chineseName:'Tên',
    directPhone:'Người giới thiệu trực tiếp',
    directindirect:'Người giới thiệu trực tiếp/gián tiếp',
    indirectPhone:'Người giới thiệu gián tiếp',
    symbolType:'Loại hình sản phẩm',
    execVolume:'Số lần giao dịch',
    complianceExecVolume:'Số lot khách hàng giao dịch/số lot đạt mục tiêu',
    complianceStatus:'Trạng thái đạt mục tiêu',
    ctime:'TG đạt mục tiêu',
    userCreateDate:'TG mở tài khoản',
    activeTime:'TG kích hoạt',
    downloadEffectiveCustomer:'Ghi chép khách hàng hiệu quả',
    downloadActivity:'Giao dịch trả thưởng',
    downloadActivity0:'Giới thiệu bạn bè',
  },
  rewardTradeDetails:{
    currentCustomerNumber:'Số TK kết toán',
    currentMobilePhone:'Số ĐT của TK kết toán',
    currentChineseName:'Họ tên của TK kết toán',
    excuteCustomerNumber:'Số tài khoản giao dịch',
    mobilePhone:'Số điện thoại của khách hàng',
    demo:'Loại hình tài khoản',
    levelType:'Cấp độ tài khoản',
    symbolType:'Loại hình sản phẩm',
    symbol:'Sản phẩm',
    orderid:'Số lệnh đặt',
    execVolume:'Số lần giao dịch',
    relationType:'Loại hình thưởng',
    directPhone:'Người giới thiệu trực tiếp',
    indirectPhone:'Người giới thiệu gián tiếp',
    currentRebete:'Số tiền',
    ctime:'TG kết toán',
    downloadTradeDetails:'Chi tiết tiền thưởng',
    depositStatus:'入账状态'
  },
  rewardDealList:{
    createDate:'TG kết toán',
    currentCustomerNumber:'Số TK kết toán',
    currentMobilePhone:'Số ĐT kết toán',
    currentChineseName:'Họ tên của khách hàng kết toán',
    customerStatus:'Loại hình tài khoản',
    accountStatusCode:'Loại hình tài khoản',
    currentRebete:'Số tiền thưởng',
    correctionRebete:'Điều chỉnh số tiền',
    finalRebete:'Trả lại cuối cùng',
    proposalStatus:'Trạng thái',
    updateUser:'Người sửa',
    updateDate:'TG sửa',
    approvalUser:'Người xét duyệt',
    approvedDate:'TG xét duyệt',
    remark:'Ghi chú(Lý do tự chối)',
    confirmSubmit:'Xác nhận đưa lên',
    confirmSuccess:"Đưa lên thành công",
    confirmFail:"Đưa lên thất bại",
    cancel:'Hủy',
    confirm:'Xác nhận',
    cancelProposal:'Hủy đề án',
    refuse:'Tự chối đề án',
    apply:'Xét duyệt',
    reason:'Lý do',
    limit:'Bảng điều chỉnh số tiền',
    refuseProposal:'Tự chối',
    downloadLimit:'Tải bảng điều chỉnh'
  },
  relationList:{
    customerRelation:'Quan hệ giới thiệu của người dùng',
    customerRelationPro:'Đề án quan hệ giới thiệu của người dùng',
    customerNum:'Số TK giao dịch',
    mobilePhone:'Số ĐT',
    userName:'Họ tên',
    userLevel:'Cấp độ tài khoản',
    createDate:'TG mở tài khoản',
    activeTime:'TG kích hoạt',
    newdirectPhone:'Người giới thiệu trực tiếp',
    remark:'Ghi chú',
    customerNumber:'Tài khoản thành viên',
    phone:'Điện thoại',
    direct:'Người giới thiệu trực tiếp/gián tiếp',
    matchType:'Quan hệ giới thiệu',
    activeStatus:'Trạng thái kích hoạt',
    demoCustomerNum:'tài khoản demo',
    directNumber:'Tài khoản của người giới thiệu trực tiếp',
    directPhone:'ĐT của người giới thiệu trực tiếp',
    indirectNumber:'Tài khoản của người giới thiệu gián tiếp',
    indirectPhone:'ĐT của người giới thiệu gián tiếp',
    inviteCode:'Mã mời',
    useInviteCode:'Mã mời tồn tại',
    directInviteCode:'Mã mời trực tiếp',
    groupName:"groupName",
    reStatus:'Kết quả phối hợp',
    proposalUser:'Người đề án',
    proposalDate:'TG đề án',
    approvalUser:'Người xét duyệt',
    approvalDate:'TG xét duyệt',
    applyProposal:"Thực thi đề án",
    cancelProposal:'Hủy đề án',
    beginDate:'TG bắt đầu mở tài khoản',
    endDate:'TG kết thúc mở tài khoản',
    proposalStatus:'Trạng thái đề án',
    proposalNo:'Số đề án',
  },
  faceConfig:{
    deleteSuccess:'Xóa thành công',
    updateSuccess:'Sửa thành công',
    code:'Mã đường lối',
    name:'Tên đường lối',
    type:'验Loại hình xác minh',
    thirdParty:'Lối kết nối bên thứ ba',
    cost:'Phí',
    status:'Trạng thái',
    remark:'Ghi chú',
    verifyCode:'Đường lối nhà máy',
    verifyType:'Loại hình xác minh',
    verifyTypeCN:'Tiếng Trung loại hình xác minh',
    describe:'Miêu tả xác minh',
    device:'Loại hình sàn',
    channel: 'Tên kênh',
    channelDesc: 'Tên kênh，Ví dụ Android: cf / iOS: com.cfd.cf',
    version: 'Phiên bản',
    versionDesc: 'Phiên bản，Ví dụ Android: 111 / iOS: 1.1.1',
    switchCode: 'Chuyển kênh',
    faceStatus: 'Khống chế khuôn mặt',
    createDate : 'TG xây dựng',
    createUser: 'Người xây dựng',
    updateUser: 'Người sửa',
    updateDate: 'TG sửa',
    submitSuccess:'Thao tác thành công',
    faceRecord:'Lịch sử xác minh',
    chineseName: 'Họ tên',
    card: 'CMND',
    phone: 'Số ĐT',
    recordDate: 'TG ghi',
    channelName : 'Tên kênh',
    result: 'So sánh kết quà',
    resultParam: 'Tra cứu chuyển ra',
    count: 'Số lần sử dụng',
    successCount: 'Số lần thành công',
    artificialCount: 'Số lần điều động thủ công thành công',
    systemCount: 'Số lượng điều động hệ thống thành công',
    needSelectRecord: 'Vui lòng chọn ít nhất một bản ghi',
  },
  creditLevel:{
    updateList:'Bảng sửa cấp độ tín dụng',
    journal:'Nhật ký sửa',
    batchImport:'Nhập vào nhiều ',
    uploadTip:'Kéo files vào đây hoặc',
    uploadTip1:'bấm để tải lên',
    uploadTip2:'10MChỉ tải lên các files xlsx và không quá 10 triệu',
    uploadSuc:'Tải lên thành công',
    uploadFail:'Tải lên không thành công',
    downTemplate:'Tải xuống mẫu',
    uploadFile:'Tải lên ngay bây giờ',
    batchUpdate:'Sửa đổi hàng loạt',
    customerNo: 'Tài khoản thành viên',
    pkey: 'Thẻ P',
    creditLevelOld: 'Mức tín dụng trước khi sửa đổi',
    creditLevelOriginal: 'Mức tín dụng hiện tại của người dùng',
    creditLevel:'Mức tín dụng',
    remark:'Ghi chú',
    createDate :'TG xây dựng',
    createUser: 'Người tạo',
    updateUser: 'Người sửa',
    updateDate: 'Thời gian sửa đổi',
  },
  starLevel:{
    updateList:'Danh sách sửa đổi cấp sao',
    journal:'Nhật ký sửa',
    batchImport:'Nhập vào nhiều ',
    uploadTip:'Kéo files vào đây hoặc',
    uploadTip1:'bấm để tải lên',
    uploadTip2:'10MChỉ tải lên các files xlsx và không quá 10 triệu',
    uploadSuc:'Tải lên thành công',
    uploadFail:'Tải lên không thành công',
    downTemplate:'Tải xuống mẫu',
    uploadFile:'Tải lên ngay bây giờ',
    batchUpdate:'Sửa đổi hàng loạt',
    customerNo: 'Tài khoản thành viên',
    starLevelOld: 'Cấp sao trước khi sửa đổi',
    starLevelOriginal: 'Cấp sao người dùng hiện tại',
    starLevel:'Cấp sao',
    remark:'Ghi chú',
    createDate :'TG xây dựng',
    createUser: 'Người tạo',
    updateUser: 'Người sửa',
    updateDate: 'Thời gian sửa đổi',
    update:'Sửa ',
    dataType:'Loại sửa đổi',
  },
  rebateComponents:{
    subtotal:'Tiểu tính',
    total:'Tổng tính',
    tradeLogList:'Bản ghi chi tiết trả lại',
    cancel:'Hủy bỏ',
    confirm:'Xác nhận',
    symbolType:'Loại sản phẩm',
    displayName:'Sản phẩm',
    orderId:'Số vị thế',
    execVolume:'Số lot giao dịch',
    rebateAmount:'Số tiền trả',
    activeName:'tên hoạt động',
    activity:'thời gian hoạt động',
    activeId:'ID hoạt động',
    effective:'Thiết lập điều kiện khách hàng hiệu quả',
    tips:'Thời gian mở và kích hoạt tài khoản khách hàng mới phải trong thời gian hoạt động',
    beginDate: "Thời gian bắt đầu",
    endDate: "Thời gian kết thúc",
    expDate: "Ngày bắt đầu của thời hạn hiệu lực",
    expDay: "Thời hạn hiệu lực",
    productType: "Loại sản phẩm",
    me: "Khách hàng",
    direct: "Đề xuất Trực tiếp",
    indirect: "Đề xuất gián tiếp",
    quantity: "Yêu cầu lô giao dịch",
    highAmount:'Số tiền thưởng cao nhất',
    highAmount2:'Giảm giá đóng góp cao nhất của khách hàng mới',
    highPoint:'Đề xuất của khách hàng tích lũy khoản giảm giá cao nhất',
    add:'Thêm',
    update:'Sửa',
    dollar:'USD',
    day:'ngày',
    activeTime:'TG kích hoạt',
    reward:'Cài đặt tiền thưởng giới thiệu',
    rebate:'Cài đặt giao dịch trả lại',
    addCondition:'Thêm điều kiện',
    min:'Mini',
    std:'Tiêu chuẩn',
    vip:'Bạch kim',
    to:'đến',
    all:'toàn bộ',

  },
  risk:{
    name:"Tên cổng",
    baseSetting:"Cấu hình người dùng cơ bản",
    specialSetting:"Cấu hình người dùng cụ thể",
    ipSetting:"cấu hình quy tắc ip",
    addBaseSetting:"Thêm nhóm người dùng quy tắc",
    addspecialSetting:"Thêm nhóm người dùng cụ thể",
    settingTpye:"Loại cấu hình",
    userType:"Nhóm người dùng",
    pkey:"Thẻ P",
    nkey:"Thẻ N",
    creditLevel:"Mức tín dụng",
    utmSource:"Nguồn",
    utmMedium:"Môi giới",
    utmCampaign:"Loại quảng cáo",
    limitSetting:"Giới hạn Quy tắc",
  },
  registervalidate:{
    customerNo:"Tài khoản",
    registerType:"Loại mở tài khoản",
    target:"Dãn hiệu",
    creditTunnel2:"Kênh tín dụng 2",
    creditTunnel3:"Kênh tín dụng 3",
    validateStatus2:"Trạng thái xác thực hai phần tử",
    validateStatus3:"Trạng thái xác thực ba phần tử",
    registerStatus:"Trạng thái mở tài khoản",
    channel:"nguồn kênh",
    kycResult:"kết quả xác minh kyc",
    personMarkTunnel:"Kênh điều tra tín dụng",
    personMarkResult:"Kết quả xác minh điều tra vụ kiện tín dụng",
    creditLoanTunnel:"Kênh tín dụng quá hạn",
    creditLoanResult:"Kết quả xác minh tín dụng quá hạn",
  },
  tracker:{
    customerNo:"Tài khoản Người dùng",
    openStartTime:"Thời gian bắt đầu mở tài khoản",
    openEndTime:"Thời gian kết thúc mở tài khoản",
    activeStartTime:"Thời gian bắt đầu kích hoạt",
    activeEndTime:"Thời gian kết thúc kích hoạt",
    userType:"Loại tài khoản",
    isActive:"Trạng thái Kích hoạt",
    isShow:"Hiển thị / ẩn đoạn cột",
    businessType:"Nhóm kinh doanh",
    relatedAccount:"Tài khoản được Liên kết",
    levelType:"Cấp tài khoản",
    userAge:"Tuổi",
    gender:"Giới tính",
    birthday:"Ngày sinh",
    ctime:"Ngày mở tài khoản",
    pkey:"Nhãn P",
    nkey:"Nhãn N",
    creditLevel:"Mức tín dụng",
    href:"url nguồn",
    utmSource:"nguồn",
    utmMedium:"Môi giới",
    utmCampaign:"Loại quảng cáo",
    utmContent:"Nhón quảng cáo",
    utmTerm:"Chữ quan trọng",
    activeTime:"Thời gian kích hoạt",
    ipAddress:"Vị trí IP",
    userAgent:"Trình duyệt",
    checkStatus:"Trạng thái xác minh IVI",
    arbitrageurTags:"Thẻ xác minh IVI",
    directAccount:"tài khoản của người giới thiệu",
    directPhone:"số điện thoại di động của người giới thiệu",
    tracker:"Theo dõi Người dùng",
    inviteCode:'Mã mời',
    isInviteCode:'Mã mời tồn tại',
    directInviteCode:'Mã mời trực tiếp',
    groupName:"groupName",
  },
  activeTemplate:{
    type:"Loại chương trình",
    url:"Tên miền phát biểu",
    detail:"Mẫu mô-đun",
    field:"Thuộc tính quảng cáo",
    fieldTitle:"Tên thuộc tính",
    fieldField:"Mã thuộc tính",
    fieldType:"Loại hình thuộc tính",
    text:"chữ",
    img:"Ảnh",
    title:"Tiêu đề mẫu",
    activeTime:"TG chương trình",
    author:"Người phát biểu",
  },
  advertising:{
    advertisingStats: "Thống kê dữ liệu quảng cáo",
    key: "phím",
    value: "Giá trị",
    type: "loại",
    adverType: "adverType",
    adverId: "adverId",
    account: "account",
    exportAccount: "exportAccount",
    createTime:"Tạo thời gian",
    name:"Tên quảng cáo",
    platform:"Ứng dụng nền tảng",
    term:"Hiệu lực",
    accountType:"Loại tài khoản",
    isActive:"Trạng thái kích hoạt",
    userLevel:"Cấp tài khoản",
    aboutType:"Mức độ chuyển đổi",
    position:"Vị trí quảng cáo",
    positionType:"Các loại quảng cáo",
    channel:"kênh",
    adverInfo:"Chi tiết quảng cáo",
    startTime:"Thời gian bắt đầu",
    endTime:"Thời gian hiệu lực",
    status:"Trạng thái",
    carapace:"Áo khoác",
    time:"Có hiệu lực",
    param:"Cho người dùng",
    url:"Tải lên hình ảnh",
    title:"Tiêu đề",
    address:"Địa chỉ",
    content:"Nội dung",
    sort:"Sắp xếp",
    simulation:"Mô phỏng",
    real:"Thực tế",
    demoCaseReal:"Chuyển đổi mô phỏng thực sự",
    stats:"Thống kê quảng cáo",
    positionName:"Tên vị trí quảng cáo",
    accountId:"Tài khoản giao dịch",
    clickCount: "Số nhấp chuột",
    clickToOpenCount: "Số lần nhấp chuột",
    actionTime:"Thời gian hoạt động",
    deleted: "Đã xóa",
  },
  analy:{
    dayActive:"Số kích hoạt tức thời trong ngày",
    dayReal:"TK thật trong ngày",
    dayDemo:"TK demo trong ngày",
    dayRealDemo:"TK thật+TK demo trong ngày",
    in:"Trong đó",
    dayRealActive:"Số mở TK và kích hoạt trong ngày",
    weekActiveCount:"Số kích hoạt vào 7 ngày gần đây",
    weekRealCount:"Số mở TK thật vào 7 ngày gần đây",
    weekDemoCount:"Số mở TK demo vào 7 ngày gần đây",
    weekRealDemoCount:"Số TK thật+demo mở vào 7 ngày gần đây ",
    realCount:"Số TK thật",
    demoCount:"Số TK demo",
    realDemoCount:"Số TK thật+demo",
    averCount:"Đường bình quân ngày làm việc",
    week0:"Chủ Nhật",
    week1:"Thứ Hai",
    week2:"Thứ Ba",
    week3:"Thứ Tư",
    week4:"Thứ Năm",
    week5:"Thứ Sáu",
    week6:"Thứ Bảy",
    dayActiveRate:"Tỷ lệ Kênh của TK kích hoạt tức thời trong ngày",
    dayRealRate:"Tỷ lệ Kênh của mở TK thật tức thời trong ngày",
    dayDemoRate:"Tỷ lệ Kênh của mở TK demo tức thời trong ngày",
    dayRealDemoRate:"Tỷ lệ Kênh của mở TK thật+demo tức thời trong ngày",
    dayRealCount:"Số TK thật mở tức thời trong ngày",
    dayDemoCount:"Số TK demo mở tức thời trong ngày",
    dayRealDemoCount:"Số tài khoản thật+demo mở tức thời trong ngày",
    today:"Hôm nay",
    yesterday:"Hôm qua",
    activeCount:"Số kích hoạt",
  },
  smsType:{
    device:"Trang bên",
    type:"Phương pháp mã xác minh",
    updateTime:"Thay đổi thời gian",
    modify:"Phương thức chuyển đổi"
  },
  emailTemplate:{
  	emailTemplate:"mẫu email",
    templateName:"Tên mẫu",
    title:"tiêu đề",
    enabled:"Trạng thái",
    updateDate: 'Cập nhật ngày tháng',
    senderName: "Tên người gửi",
    smtpHost: "Máy chủ SMTP",
    smtpPort: "Cổng SMTP",
    smtpUser: "Người dùng SMTP",
    smtpPassword: "Mật khẩu SMTP"
  },
  emailSend:{
    sendEmail:"Gửi email",
    title:"tiêu đề",
    sendCount:"Gửi số lượng",
    sucCount:"Số lượng thành công",
    failCount:"không đếm được",
    updateDate: 'Cập nhật ngày tháng',
    sendType:"Gửi loại",
    chooseTemplate:"Chọn mẫu",
    content:"Nội dung email",
    receiver:"người nhận",
    uploadReceiver:"Tải lên người nhận",
    emailList:"Danh sách email",
    uploadTip:'Kéo files vào đây hoặc',
    uploadTip1:'bấm để tải lên',
    uploadTip2:'1、Nhiều hộp thư được phân tách bằng dấu phẩy tiếng Anh',
    uploadTip3:'2、Mỗi lần tải lên sẽ ghi đè hộp thư trước đó',
    uploadTip4:'3、Mỗi lần gửi không được vượt quá 5,000 hộp thư và nó có thể được gửi nhiều lần nếu vượt quá',
    uploadTip5:'4、Danh sách email chỉ hỗ trợ định dạng tệp .txt hoặc .csv',
    uploadTip6:'1、Tệp đính kèm chỉ hỗ trợ định dạng tệp .pdf',
    uploadTip7:'2、Mỗi tệp đính kèm không được có kích thước vượt quá 10MB',
    uploadSuc:'Tải lên thành công',
    uploadFail:'Tải lên không thành công',
    uploadFile:'Tải lên ngay bây giờ',
    attachment:'Tập tin đính kèm',
    selectAttachment:'Chọn tệp đính kèm',
    deleteAll:'Xóa hết',
    chooseChannel:"Chọn kênh",
    sender:"Người gửi",
    emailId: "(VN) 邮件ID",
    customerEmailAddress: "(VN) 客户邮箱号",
    actionDatetime: "(VN) 操作时间",
    emailStats: "(VN) 邮件数据统计",
    statsDetails: "(VN) 数据详情",
    openRate: "(VN) 打开率",
  },
  emailChannel:{
    emailChannel:"Kênh email",
    channelName:"Tên kênh",
    emailAddress:"Địa chỉ email",
    enabled:"Trạng thái",
    updateDate: 'Cập nhật ngày tháng',
  },
  optional:{
    iCodeId: "code",
    symbol: "symbol",
    platform: "platform",
    businessType: "businessType",
    accountNo: "accountNo",
    account: "account",
    createTime: "create Time",
    channel: "channel",
  },
};
